module.exports = __webpack_public_path__ + "assets/img/a35123259df98cc9adbb76b5e5eaad62.png";